module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CG - Republic of the Congo.d7676aca.svg";